<template>
  <div class="playground">
    <preview-frame :task-id="taskId" type="source"></preview-frame>
    <div id="preview-editors"></div>
  </div>
</template>

<script>
    import {
        TASK_PLAYGROUND_REQUEST,
        USER_TASK_START,
        VALIDATE_USER_ANSWER
    } from "../../../store/actions/task";

    import SkeletonBox from "../../../components/SkeletonBox";
    import PreviewFrame from "../../../components/task/PreviewFrame";
    import WorkflowArea from "../../../components/task/WorkflowArea";
    import CodeMirrorHelper from "../../../utils/codemirror"

    export default {
        name: "TaskPlaygroundPreview",
        components: {WorkflowArea, PreviewFrame, SkeletonBox},
        props: ['taskId'],
        data() {
            return {
                taskPlayground: {
                    id: null,
                    sources: []
                }
            }
        },
        created() {
            if (!this.$store.getters.getCurrentUserTask)
                this.$store.dispatch(USER_TASK_START, this.taskId).then().catch(err => console.log(err));

            this.$store.dispatch(TASK_PLAYGROUND_REQUEST, this.taskId).then((taskPlayground) => {
                this.taskPlayground = taskPlayground;
                this.initCodeEditors();
            });
        },
        methods: {
            initCodeEditors() {
                this.taskPlayground.sources.forEach(source => {
                    if(source.show) {
                        let editorElement = document.createElement('div');
                        editorElement.classList.add('playground-code-editor');
                        editorElement.id = `codePreviewEditor${source.mode}`;

                        document.getElementById('preview-editors').append(editorElement);

                        this.initPreviewCodeMirror(editorElement, source.mode, source.code);
                    }
                });
            },
            initPreviewCodeMirror(editorElement, mode, code) {
              CodeMirrorHelper.initCodeMirrorArea(editorElement, mode, code, true);
            }
        }
    }
</script>

<style lang="scss">
  .CodeMirror {
    &-mode {
      &-badge {
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 999;
        background-color: #eee;
        padding: 1px 6px;
        font-size: 10px;
        border-radius: 5px;
      }
    }
  }
</style>
